import { Tooltip } from "@chakra-ui/react";
import React from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormHiddenInput } from "shared/components/form/FormHiddenInput";
import { FormCheckbox } from "shared/components/input/checkbox/Checkbox";
import { FormDateInput } from "shared/components/input/date/DateInput";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";

const CapitalEventDateForm: React.FC = () => {
  const { t } = useTranslation(["capitalActivity", "common"]);

  const differentCapitalCallDate = useWatch({
    name: "different_capital_call_date",
  }) as boolean | null;

  return (
    <>
      <FormDateInput
        name={
          differentCapitalCallDate ? "capital_call_posted_date" : "posted_date"
        }
        title={
          differentCapitalCallDate
            ? t("capitalActivity:dates.capitalCallInvestorNoticeDate")
            : t("capitalActivity:dates.investorNoticeDate")
        }
      />
      <FormDateInput
        name={
          differentCapitalCallDate
            ? "capital_call_effective_date"
            : "effective_date"
        }
        title={
          differentCapitalCallDate
            ? t("capitalActivity:dates.capitalCallDueDate")
            : t("capitalActivity:dates.dueDate")
        }
      />
      <FormCheckbox name="different_capital_call_date" marginBottom="8px">
        {t("capitalActivity:dates.toggleText")}
        <Tooltip
          key="tooltip"
          label={t("capitalActivity:dates.toggleHelpText")}
          placement="top"
        >
          <InfoCircleIcon w="12px" h="12px" ml="10px" color="gray.400" />
        </Tooltip>
      </FormCheckbox>
      {differentCapitalCallDate ? (
        <FormDateInput
          name="posted_date"
          title={t("capitalActivity:dates.distributionInvestorNoticeDate")}
        />
      ) : (
        <FormHiddenInput name="capital_call_posted_date" value={undefined} />
      )}
      {differentCapitalCallDate ? (
        <FormDateInput
          name="effective_date"
          title={t("capitalActivity:dates.distributionDueDate")}
        />
      ) : (
        <FormHiddenInput name="capital_call_effective_date" value={undefined} />
      )}
    </>
  );
};

export default CapitalEventDateForm;
